import "./styles.scss";

import { useState } from "react";
import classnames from "classnames";
import { Collapse } from "react-collapse";
import { useTranslation } from "react-i18next";

import { useApp } from "context/app";

import AnimatedGradient from "components/AnimatedGradient";
import Button from "components/Button";

import { ReactComponent as ThundersIcon } from "assets/icons/new/thunders.svg";
import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";

import useResponsive from "libs/helpers/useResponsive";
import getGradientPropsByStatus from "libs/helpers/getGradientPropsByStatus";
import getRawStatusById from "libs/helpers/getRawStatusById";

const mainClass = "dashboard-website-status";

const WebsiteStatus = ({ data, list_items }) => {
  const { t } = useTranslation();
  const { min, max } = useResponsive();
  const { theme } = useApp();

  const [isExpanded, setIsExpanded] = useState(0);

  const status_data = [
    {
      id: 0,
      label: t("Payment problem"),
      text: t(
        "There was a problem paying for your subscription. Check your payment method details and make sure they are up to date",
      ),
    },
    {
      id: 1,
      label: t("Everything is fine"),
      text: t(
        "Your website is safe and up to date. Your payment method is active.",
      ),
    },
    {
      id: 2,
      label: t("Payment problem"),
      text: t(
        "There was a problem paying for your subscription. Check your payment method details and make sure they are up to date",
      ),
    },
    {
      id: 3,
      label: t("Verification in progress"),
      text: t(
        "It may take up to 24h for us to verify if everything is ok with your website",
      ),
    },
    {
      id: 4,
      label: t("Website does not respond"),
      text: t(
        "There may be a problem with your website or its server. We have received an automatic notification of the issue and are working to resolve it.",
      ),
    },
  ];

  const current_status = status_data?.find((item) => item?.id === data?.status);

  const ListItemHeader = max.lg ? "div" : "button";

  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--${current_status?.id}`]: !!current_status?.id,
      })}
    >
      <div className={`${mainClass}__wrapper`}>
        <div className={`${mainClass}__header`}>
          <div className={`${mainClass}__header__icon`}>
            <ThundersIcon />
          </div>
          <div className={`${mainClass}__header__text`}>
            <span>{t("Website status")}</span>
            <span>{t("Basic information about your site.")}</span>
          </div>
        </div>
        <div className={`${mainClass}__status`}>
          <h1>{current_status?.label}</h1>
          <p>{current_status?.text}</p>
        </div>
        {min.sm && list_items?.length > 0 && (
          <div className={`${mainClass}__list`}>
            {list_items.map((item, index) => (
              <div
                key={index}
                className={classnames(`${mainClass}__list__item`, {
                  [`${mainClass}__list__item--expanded`]:
                    !max.lg && isExpanded === index,
                })}
              >
                <ListItemHeader
                  className={`${mainClass}__list__item__header`}
                  {...(!max.lg && {
                    type: "button",
                    onClick: () =>
                      setIsExpanded(isExpanded === index ? null : index),
                  })}
                >
                  <div className={`${mainClass}__list__item__header__icon`}>
                    {item.icon}
                  </div>
                  <div className={`${mainClass}__list__item__header__text`}>
                    <span>{item.title}</span>
                    <span>{item.description}</span>
                  </div>
                  <div className={`${mainClass}__list__item__header__aside`}>
                    {(max.lg || isExpanded === index) && item?.aside}
                    {!max.lg && <ArrowIcon />}
                  </div>
                </ListItemHeader>
                <Collapse isOpened={max.lg || isExpanded === index}>
                  {item?.component ? (
                    <div className={`${mainClass}__list__item__content`}>
                      {item?.component}
                    </div>
                  ) : (
                    <div className={`${mainClass}__list__item__content`}>
                      {item?.content?.map((content, index) => (
                        <div
                          key={index}
                          className={`${mainClass}__list__item__content__item`}
                        >
                          <span>{content.label}</span>
                          <span>{content.value}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </Collapse>
              </div>
            ))}
          </div>
        )}
        {max.sm &&
          (current_status?.id === 1 ||
            current_status?.id === 0 ||
            current_status?.id === 2) && (
            <div className={`${mainClass}__buttons-mobile`}>
              {current_status?.id === 1 ? (
                <>
                  <Button href={`/websites/${data?._id}`}>
                    {t("More informations")}
                  </Button>
                  <Button
                    variant="transparent"
                    href={`/tasks?website=${data?._id}`}
                  >
                    {t("Tasks")}
                  </Button>
                </>
              ) : current_status?.id === 0 || current_status?.id === 2 ? (
                <Button href="/invoices">{t("Payments")}</Button>
              ) : null}
            </div>
          )}
      </div>
      <div
        className={classnames(`${mainClass}__background`, {
          [`${mainClass}__background--${getRawStatusById(current_status?.id)}`]:
            current_status?.id !== undefined,
        })}
      >
        {min.sm && (
          <AnimatedGradient
            id="status-gradient"
            {...getGradientPropsByStatus(current_status?.id, theme)}
          />
        )}
      </div>
    </div>
  );
};

export default WebsiteStatus;
